import { createFileRoute } from '@tanstack/react-router';
import { useDashboardContext } from './dashboard-context';
import { ClaimsDashboard } from './sections/Claims';
import { FleetClaimsDashboard } from './sections/Claims/Fleet';

export const Route = createFileRoute('/console/$orgId/dashboard/claims')({
    component: RouteComponent,
});

function RouteComponent() {
    const { refetchSignal, showFleetClaimsDashboard } = useDashboardContext();

    return showFleetClaimsDashboard ? <FleetClaimsDashboard /> : <ClaimsDashboard key={refetchSignal.claims} />;
}
